module.exports = __webpack_public_path__ + "img/sieckFinesseRelease8.de5cfd4d.png";